package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.VideoOutline: ImageVector
    get() {
        if (_videoOutline != null) {
            return _videoOutline!!
        }
        _videoOutline = Builder(name = "VideoOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 16.0f, viewportHeight = 16.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(5.625f, 10.875f)
                lineTo(6.8749f, 10.875f)
                lineTo(6.8749f, 8.375f)
                lineTo(9.375f, 8.375f)
                lineTo(9.375f, 7.125f)
                lineTo(6.8749f, 7.125f)
                lineTo(6.8749f, 4.625f)
                lineTo(5.625f, 4.625f)
                lineTo(5.625f, 7.125f)
                lineTo(3.125f, 7.125f)
                lineTo(3.125f, 8.375f)
                lineTo(5.625f, 8.375f)
                lineTo(5.625f, 10.875f)
                lineTo(5.625f, 10.875f)
                moveTo(1.5064f, 13.9999f)
                curveTo(1.0855f, 13.9999f, 0.7292f, 13.8541f, 0.4375f, 13.5624f)
                curveTo(0.1458f, 13.2708f, 0.0f, 12.9145f, 0.0f, 12.4935f)
                lineTo(0.0f, 3.0064f)
                curveTo(0.0f, 2.5855f, 0.1458f, 2.2292f, 0.4375f, 1.9375f)
                curveTo(0.7292f, 1.6458f, 1.0855f, 1.5f, 1.5064f, 1.5f)
                lineTo(10.9935f, 1.5f)
                curveTo(11.4145f, 1.5f, 11.7708f, 1.6458f, 12.0624f, 1.9375f)
                curveTo(12.3541f, 2.2292f, 12.4999f, 2.5855f, 12.4999f, 3.0064f)
                lineTo(12.4999f, 6.8205f)
                lineTo(15.4326f, 3.8878f)
                lineTo(15.4326f, 11.6121f)
                lineTo(12.4999f, 8.6794f)
                lineTo(12.4999f, 12.4935f)
                curveTo(12.4999f, 12.9145f, 12.3541f, 13.2708f, 12.0624f, 13.5624f)
                curveTo(11.7708f, 13.8541f, 11.4145f, 13.9999f, 10.9935f, 13.9999f)
                lineTo(1.5064f, 13.9999f)
                lineTo(1.5064f, 13.9999f)
                moveTo(1.5064f, 12.75f)
                lineTo(10.9935f, 12.75f)
                curveTo(11.0683f, 12.75f, 11.1298f, 12.7259f, 11.1778f, 12.6778f)
                curveTo(11.2259f, 12.6298f, 11.25f, 12.5683f, 11.25f, 12.4935f)
                lineTo(11.25f, 3.0064f)
                curveTo(11.25f, 2.9316f, 11.2259f, 2.8702f, 11.1778f, 2.8221f)
                curveTo(11.1298f, 2.774f, 11.0683f, 2.75f, 10.9935f, 2.75f)
                lineTo(1.5064f, 2.75f)
                curveTo(1.4316f, 2.75f, 1.3702f, 2.774f, 1.3221f, 2.8221f)
                curveTo(1.274f, 2.8702f, 1.25f, 2.9316f, 1.25f, 3.0064f)
                lineTo(1.25f, 12.4935f)
                curveTo(1.25f, 12.5683f, 1.274f, 12.6298f, 1.3221f, 12.6778f)
                curveTo(1.3702f, 12.7259f, 1.4316f, 12.75f, 1.5064f, 12.75f)
                lineTo(1.5064f, 12.75f)
                moveTo(1.25f, 12.75f)
                curveTo(1.25f, 12.75f, 1.25f, 12.7259f, 1.25f, 12.6778f)
                curveTo(1.25f, 12.6298f, 1.25f, 12.5683f, 1.25f, 12.4935f)
                lineTo(1.25f, 3.0064f)
                curveTo(1.25f, 2.9316f, 1.25f, 2.8702f, 1.25f, 2.8221f)
                curveTo(1.25f, 2.774f, 1.25f, 2.75f, 1.25f, 2.75f)
                lineTo(1.25f, 2.75f)
                curveTo(1.25f, 2.75f, 1.25f, 2.774f, 1.25f, 2.8221f)
                curveTo(1.25f, 2.8702f, 1.25f, 2.9316f, 1.25f, 3.0064f)
                lineTo(1.25f, 12.4935f)
                curveTo(1.25f, 12.5683f, 1.25f, 12.6298f, 1.25f, 12.6778f)
                curveTo(1.25f, 12.7259f, 1.25f, 12.75f, 1.25f, 12.75f)
                lineTo(1.25f, 12.75f)
                lineTo(1.25f, 12.75f)
            }
        }
        .build()
        return _videoOutline!!
    }

private var _videoOutline: ImageVector? = null
